import { render, staticRenderFns } from "./IconGroup.vue?vue&type=template&id=7084e263&scoped=true"
var script = {}
import style0 from "./IconGroup.vue?vue&type=style&index=0&id=7084e263&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084e263",
  null
  
)

export default component.exports